import { API } from "aws-amplify";

import { initData, getHeaderAuth } from "utils/utilAmplify";
import { generateErrorResponse } from "utils/helpers";
import { IEmail, IPerson } from "interfaces/intarfaces";

export const UserAPI = {
  get: async (url: string = "") => {
    try {
      return await API.get("UsersProfile", url, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },

  create: async (url: string = "", body: Partial<IPerson>) => {
    try {
      return await API.post("UsersProfile", url, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },

  update: async (url: string = "", body: Partial<IPerson>) => {
    try {
      return await API.patch("UsersProfile", url, {
        ...(await initData()),
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },

  delete: async (url: string = "") => {
    try {
      return await API.del("UsersProfile", url, await initData());
    } catch (error) {
      return generateErrorResponse(error);
    }
  },

  upload: async (path: string = "", body: File | string) => {
    const formData = new FormData();
    formData.append("user_image", body);

    const dataInitial: RequestInit = {
      headers: {
        ...(await getHeaderAuth()),
        Accept: "image/jpeg",
      },
      body: formData,
    };

    try {
      return await API.post("UsersProfile", path, dataInitial);
    } catch (error) {
      return generateErrorResponse(error);
    }
  },

  email: async (contact_email: string = "", body: IEmail) => {
    try {
      return await API.post("UsersProfile", `contact-us/${contact_email}`, {
        body: JSON.parse(JSON.stringify(body)),
      });
    } catch (error) {
      return generateErrorResponse(error);
    }
  },
};
